const STORAGE_KEYS = {
  pharmacy: 'hms_invoice_is_gst_bill_pharmacy',
  lab: 'hms_invoice_is_gst_bill_lab'
};

/**
 * @param {'pharmacy' | 'lab'} variant
 * @returns {boolean | null} null if unset or invalid
 */
export function getStoredInvoiceGstBill(variant) {
  if (variant !== 'pharmacy' && variant !== 'lab') return null;
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEYS[variant]);
    if (raw === null) return null;
    if (raw === 'true') return true;
    if (raw === 'false') return false;
  } catch {
    // ignore quota / private mode
  }
  return null;
}

/**
 * @param {'pharmacy' | 'lab'} variant
 * @param {boolean} enabled
 */
export function setStoredInvoiceGstBill(variant, enabled) {
  if (variant !== 'pharmacy' && variant !== 'lab') return;
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEYS[variant], enabled ? 'true' : 'false');
  } catch {
    // ignore
  }
}
